import React from 'react';

import { COLOR } from '@/theme/colors';
import { SVGIconProps } from '@/types/svg';

const PlusIcon: React.FC<SVGIconProps> = ({
    width = 15,
    height = 15,
    color = COLOR.black,
}) => {
    return (
        <svg
            height={width}
            width={height}
            id="base-circle-off-white"
            viewBox={'0 0 20 20'}
        >
            <path
                d="M221.06 812.23c-5.43 0-9.84 4.4-9.84 9.84s4.4 9.84 9.84 9.84 9.84-4.4 9.84-9.84-4.41-9.84-9.84-9.84z"
                transform="translate(-211.062 -812.062)"
                fill="#ffffff"
            />

            <path
                d="M221.06 813.82a8.241 8.241 0 0 0 0 16.48 8.241 8.241 0 0 0 0-16.48zm3.3 9.07h-2.47v2.47a.82.82 0 0 1-.8.85.82.82 0 0 1-.85-.8V822.88h-2.47c-.45.02-.84-.34-.85-.8s.34-.84.8-.85H220.25v-2.47c-.02-.45.34-.84.8-.85s.84.34.85.8V821.24h2.47c.45-.02.84.34.85.8.02.46-.34.84-.8.85h-.06z"
                fill={color}
                transform="translate(-211.062 -812.062)"
            />
        </svg>
    );
};

export default PlusIcon;
